import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Weeks.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("table", [
    _c(
      "thead",
      { staticClass: "weekdays" },
      _vm._l(_vm.weekdays, function(weekday) {
        return _c("th", { key: weekday, staticClass: "weekday" }, [
          _vm._v("\n            " + _vm._s(weekday) + "\n        ")
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "tbody",
      _vm._l(_vm.weeks, function(week, i) {
        return _c(
          "tr",
          { key: i, staticClass: "week" },
          _vm._l(week, function(day) {
            return _c("Day", {
              key: day.date.getDate(),
              attrs: { day: day, "data-cy": "day" },
              on: { "date-selected": _vm.onDateSelected }
            })
          }),
          1
        )
      }),
      0
    )
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-4a53c1b0";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Calendar/Weeks.vue.js